import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useSchedule } from 'modules/shift_management/hooks/useSchedule'

const DisabledCell = () => {
  const [{ view }] = useSchedule()

  return (
    <Box
      height="full"
      minHeight={view.cellMinHeight}
      flexGrow
      border={{
        all: {
          width: 's2',
          style: 'hidden',
          color: 'grey200',
        },
      }}
      background="grey100"
    />
  )
}

export default observer(DisabledCell)
